export default __webpack_public_path__ + "static/media/mohe-logo.47207cf6.svg";